import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { AppService } from 'src/app/services/app.service';

import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  setitem: any = [];
  statusMenu: boolean = false;
  @Input('menuStatus') set setValue(v: boolean) {
    this.statusMenu = v;
  }
  @Output('updateMenu') updateMenu = new EventEmitter()
  constructor(private app: AuthService,
    public sv: AppService,
    private http: HttpClient,
    private kc: KeycloakService) {
    this.getProfile();

  }
  profile: any;
  contact: boolean = false;
  viewContact() {
    this.contact = !this.contact
    this.profile.view = !this.profile.view
  }

  getProfile() {
    this.http.get("Profile").subscribe({
      next: (res: any) => {
        this.profile = res.data
        this.profile.view = false
      }
    })
  }

  viewMenu(elm: any, v: any) {
    let model: any[] = [];
    // model.push({ label: 'โปรไฟล์', command: () => {  } });
    model.push({ label: 'ออกจากระบบ', command: () => { this.logout() } });


    this.setitem = model;
    elm.toggle(v);
  }


  logout() {
    sessionStorage.removeItem('realmid')
    sessionStorage.removeItem('ogid')
    sessionStorage.removeItem('license')
    this.kc.logout()
  }

  closeProfile() {
    this.profile.view = false;
  }

  toDashoboard() {
    this.app.setTo('https://dashboard.legitid.org')
  }

  changeStatusMenu() {
    this.statusMenu = !this.statusMenu
    this.updateMenu.emit(this.statusMenu)
  }

}
